module.exports = __webpack_public_path__ + "static/media/colheitadeira2.6b7a6dac.svg";